package com.tedd.db

import kotlin.Long
import kotlin.String

public data class Portfolio_piece_competence(
  public val id: String,
  public val piece_id: String,
  public val competence_id: String,
  public val criterion_id: String?,
  public val note: String?,
  public val order_index: Long,
  public val created_at: Long,
  public val updated_at: Long,
  public val is_deleted: Long,
  public val deleted_at: Long?,
  public val synced_at: Long?,
)
